import FetchBase from '../Api/FetchBase'
import { observable, action } from 'mobx'
import {
  API_ENDPOINTS,
  DEFAULT_PAGE_START,
  DEFAULT_PER_PAGE_RECORD,
  TOP_RECORDS_LIMIT,
} from '../Utils/constants'
import {
  getCurrentTimeMoment,
  getStartDate,
  getUtcUnixSelectDate,
} from '../Utils/rules'

export default class HomeStore extends FetchBase {
  @observable customerVsProjectLoader = false
  @observable customerVsProjectTotal = 0
  @observable customerVsProjects = []

  @observable projectVsResourcesLoader = false
  @observable projectVsResourcesTotal = 0
  @observable projectVsResources = []

  @observable dashboardListActionItemsLoader = false
  @observable dashboardListActionItemsTotal = 0
  @observable dashboardListActionItems = []

  @observable selectedProjectUser = undefined
  @observable projectsPerUserTotal = 0
  @observable projectsPerUsers = []
  @observable projectsPerUserLoader = false
  @observable projectsByUserAssignedLoader = false
  @observable projectsByUsersAssigned = []
  @observable projectsByUserLoader = false
  @observable projectsByUserTotal = 0
  @observable projectsByUsers = []
  @observable dashboardReadinessReportLoader = false
  @observable dashboardReadinessReportTotal = 0
  @observable dashboardReadinessReport = []
  @observable allReadinessReportFilters = {}
  @observable allReadinessReportSearchText = ''
  @observable allReadinessReportPageNo = DEFAULT_PAGE_START
  @observable allReadinessReportDateChoice = undefined
  @observable orderingReadinessReport = undefined
  @observable orderingByReadinessReport = undefined
  @observable allReadinessReportLoader = false
  @observable allReadinessReportTotal = 0
  @observable allReadinessReport = []
  @observable statsLoader = false
  @observable statsTotalCount = 0
  @observable stats = []

  @observable currentCountryData = undefined
  @observable countryWiseProjectsLoader = false
  @observable countryWiseProjectsTotal = 0
  @observable countryNameForProjects = undefined
  @observable currentSelecteCountry = undefined
  @observable selectedCountry = undefined
  @observable countryWiseProjects = []

  @observable monthWiseProjectsLoader = false
  @observable monthWiseProjectsTotal = 0
  @observable monthYearForProjects = getCurrentTimeMoment()
  @observable monthWiseProjects = []

  @observable actionItemSearchText = ''
  @observable actionItemsFilters = {}
  @observable pfSelectedDateChoice = undefined
  @observable ordering = undefined
  @observable orderingField = undefined
  @observable allActionItems = []
  @observable allActionItemsLoader = false
  @observable allActionItemsToal = 0
  @observable allActionItemsPageNo = DEFAULT_PAGE_START

  @observable topOrganizationsLoader = false
  @observable topOrganizationsTotal = 0
  @observable topOrganizations = []

  @observable ossCommentsLoader = false
  @observable ossComments = []
  @observable spaceList = []
  @observable userList = []

  @observable ossCommentsTotal = 0
  @observable osscommentsCurrentPage = DEFAULT_PAGE_START
  @observable ossCommentsSearchText = ''
  @observable ossCommentsFilters = {}

  @action.bound
  setMonthYearProjects = (year = getCurrentTimeMoment()) => {
    this.monthYearForProjects = year
  }

  @action.bound
  setCountryNameByClicked = (values = undefined, countryGeoData = []) => {
    this.countryNameForProjects = values?.name || undefined
    values && (values['sortName'] = values?.id)
    values && (values['stateListLow'] = countryGeoData[0] || undefined)
    values && (values['stateListHigh'] = countryGeoData[1] || undefined)
    delete values?.madeFromGeoData
    this.currentCountryData = values || undefined
  }

  @action.bound
  setCountryNameForProjects = (name = undefined, values = undefined) => {
    this.countryNameForProjects = name || undefined
    this.currentSelecteCountry = name || undefined

    values && (values['sortName'] = values?.name)
    values && (values['name'] = values?.value)
    delete values?.children
    delete values?.value
    this.currentCountryData = values || undefined
  }

  @action.bound
  getCustomerVsProject = async (signal) => {
    try {
      this.customerVsProjectLoader = true
      let response = await this.get(
        API_ENDPOINTS.CUSTOMER_VS_PROJECT,
        {
          pageLimit: TOP_RECORDS_LIMIT,
        },
        signal
      )
      if (response.status) {
        this.customerVsProjectTotal = Math.min(
          response.data?.total || 0,
          TOP_RECORDS_LIMIT
        )
        this.customerVsProjects = response.data?.customerVsProject || []
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.customerVsProjectLoader = false
    }
  }

  @action.bound
  getProjectVsResources = async (signal) => {
    try {
      this.projectVsResourcesLoader = true
      let response = await this.get(
        API_ENDPOINTS.PROJECT_VS_RESOURCES,
        {
          pageLimit: TOP_RECORDS_LIMIT,
        },
        signal
      )
      if (response.status) {
        this.projectVsResourcesTotal = Math.min(
          response.data?.total || 0,
          TOP_RECORDS_LIMIT
        )
        this.projectVsResources = response.data?.projectsVsResources || []
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.projectVsResourcesLoader = false
    }
  }

  // Start Over due
  @action.bound
  getDashboardActionItems = async (signal) => {
    try {
      this.dashboardListActionItemsLoader = true
      let date = getCurrentTimeMoment()
      let options = {}
      options['endDateMax'] = getStartDate(date)
      options['orderBy'] = 'endDate'
      options['ordering'] = 'ASC'
      options['pageLimit'] = TOP_RECORDS_LIMIT

      let response = await this.get(
        API_ENDPOINTS.HOME_ACTION_ITEMS,
        {
          ...options,
        },
        signal
      )
      if (response.status) {
        this.dashboardListActionItemsTotal = Math.min(
          response.data?.total || 0,
          TOP_RECORDS_LIMIT
        )
        this.dashboardListActionItems = response.data?.actionItems || []
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.dashboardListActionItemsLoader = false
    }
  }

  @action.bound
  setActionItemFilters = (values = {}) => {
    this.actionItemsFilters = values
  }

  @action.bound
  setOrdering = (value = undefined) => {
    this.ordering = value
  }

  @action.bound
  setOrderingField = (value = undefined) => {
    if (value === 'space') {
      value = 'spaceName'
    } else if (value === 'actionitems') {
      value = 'title'
    }
    this.orderingField = value
  }

  @action.bound
  setActionItemSearchText = (value = '') => {
    this.actionItemSearchText = value
  }

  @action.bound
  setAllActionItemsPageNo = (page = DEFAULT_PAGE_START) => {
    this.allActionItemsPageNo = page
  }

  @action.bound
  setSelectedDateChoice = (value) => {
    this.pfSelectedDateChoice = value
  }

  @action.bound
  generateActionItemFilters = () => {
    let temp = {}

    this.actionItemSearchText && (temp['search'] = this.actionItemSearchText)
    let keys = Object.keys(this.actionItemsFilters || {})
    for (let filter of keys) {
      if (this.actionItemsFilters[filter] !== undefined) {
        temp[filter] = this.actionItemsFilters[filter]
      }
    }
    if (temp['endDate']) {
      temp['endDateMax'] = getStartDate(temp['endDate'])
    }
    delete temp['endDate']
    if (this.orderingField) {
      this.ordering && (temp['ordering'] = this.ordering)
      this.ordering && (temp['orderBy'] = this.orderingField)
    } else {
      temp['orderBy'] = 'endDate'
      temp['ordering'] = 'ASC'
    }

    return temp
  }

  @action.bound
  getAllActionItems = async () => {
    try {
      this.allActionItemsLoader = true
      let options = this.generateActionItemFilters() || {}
      let response = await this.get(API_ENDPOINTS.HOME_ACTION_ITEMS, {
        pageNo: Math.max(this.allActionItemsPageNo - 1, 0),
        ...options,
      })
      if (response.status) {
        this.allActionItems = response.data.actionItems
        this.allActionItemsToal = response.data.total || 0
        return [true, response.data]
      }
      this.allActionItems = []
      this.allActionItemsToal = 0
      return [false, undefined]
    } catch (err) {
      this.allActionItems = []
      this.allActionItemsToal = 0
      return [false, undefined]
    } finally {
      this.allActionItemsLoader = false
    }
  }

  @action.bound
  deleteActionItem = async (id, values) => {
    try {
      this.deleteActionItemLoader = true
      let response = await this.post(API_ENDPOINTS.DELETE_ACTION_ITEM, {
        ...values,
        id,
      })
      if (response.status) {
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.deleteActionItemLoader = false
    }
  }

  @action.bound
  resetAllActionItemFilterForm = () => {
    this.actionItemsFilters = {}
    this.pfSelectedDateChoice = undefined
  }

  // End Over due
  @action.bound
  setSelectedProjectUsers = async (uid) => {
    this.selectedProjectUser = uid
  }

  @action.bound
  getAllProjectsByUsers = async (signal) => {
    try {
      this.projectsByUserAssignedLoader = true
      let response = await this.post(
        API_ENDPOINTS.PROJECTS_BY_USER,
        {
          pageLimit: 0,
        },
        signal
      )
      if (response.status) {
        this.projectsByUsersAssigned = response.data?.userProjectCount || []
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.projectsByUserAssignedLoader = false
    }
  }

  @action.bound
  getProjectsPerUser = async () => {
    try {
      this.projectsPerUserLoader = true
      let options = {}
      this.selectedProjectUser && (options['userId'] = this.selectedProjectUser)
      let response = await this.post(API_ENDPOINTS.PROJECTS_BY_USER, {
        pageLimit: TOP_RECORDS_LIMIT,
        ...options,
      })
      if (response.status) {
        this.projectsPerUserTotal = Math.min(
          response.data?.userProjects?.length || 0,
          TOP_RECORDS_LIMIT
        )
        this.projectsPerUsers = response.data?.userProjects || []
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.projectsPerUserLoader = false
    }
  }

  @action.bound
  resetProjectsPerUsers = async () => {
    this.projectsPerUserTotal = 0
    this.projectsPerUsers = []
    this.projectsPerUserLoader = false
  }

  @action.bound
  setOrderingProjectsByUser = (value = undefined) => {
    this.orderingProjectsByUser = value
  }

  @action.bound
  setOrderingByProjectsByUser = (value = undefined) => {
    this.orderingByProjectsByUser = value
  }

  @action.bound
  getProjectsByUser = async () => {
    try {
      let options = {}
      options['orderBy'] = 'projectCount'
      options['ordering'] = 'DESC'
      this.projectsByUserLoader = true
      let response = await this.post(API_ENDPOINTS.PROJECTS_BY_USER, {
        pageLimit: TOP_RECORDS_LIMIT,
        ...options,
      })
      if (response.status) {
        this.projectsByUserTotal = Math.min(
          response.data?.total || 0,
          TOP_RECORDS_LIMIT
        )
        this.projectsByUsers = response.data?.userProjectCount || []
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.projectsByUserLoader = false
    }
  }

  // Home Project Report Readiness
  @action.bound
  setSelectedProjectUsers = async (uid) => {
    this.selectedProjectUser = uid
  }

  @action.bound
  getDashboardReadinessReport = async (signal) => {
    try {
      this.dashboardReadinessReportLoader = true
      let response = await this.post(
        API_ENDPOINTS.PROJECTS_READINES_REPORT,
        {
          pageLimit: TOP_RECORDS_LIMIT,
        },
        signal
      )
      if (response.status) {
        this.dashboardReadinessReportTotal = Math.min(
          response.data?.total || 0,
          TOP_RECORDS_LIMIT
        )
        this.dashboardReadinessReport =
          response.data?.projectReadinessReport || []
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.dashboardReadinessReportLoader = false
    }
  }

  @action.bound
  setOrderingReadinessReport = (value = undefined) => {
    this.orderingReadinessReport = value
  }

  @action.bound
  setOrderingByReadinessReport = (value = undefined) => {
    if (value === 'projectname') {
      value = 'name'
    }
    this.orderingByReadinessReport = value
  }

  @action.bound
  setReadinessReportFilters = (value = {}) => {
    this.allReadinessReportFilters = value
  }

  @action.bound
  setReadinessReportSearchText = (value = '') => {
    this.allReadinessReportSearchText = value
  }

  setReadinessReportPageNo = (page = DEFAULT_PAGE_START) => {
    this.allReadinessReportPageNo = page
  }

  setDateChoiceForReadinessReport = (value = undefined) => {
    this.allReadinessReportDateChoice = value
  }

  getFiltersAllReadinessReport = () => {
    let temp = {}
    this.allReadinessReportSearchText &&
      (temp['search'] = this.allReadinessReportSearchText)
    let keys = Object.keys(this.allReadinessReportFilters || {})
    for (let filter of keys) {
      if (this.allReadinessReportFilters[filter] !== undefined) {
        temp[filter] = this.allReadinessReportFilters[filter]
      }
    }

    // let { start, end } = getUtcUnixDate('completedOn', {
    //   start: temp?.startDate,
    //   end: temp?.statusDate,
    // })
    if (temp?.selectStatusDate) {
      let end = getUtcUnixSelectDate(temp?.selectStatusDate)
      temp['statusDate'] = end
    }
    delete temp['selectStatusDate']

    if (this.orderingReadinessReport) {
      temp['ordering'] = this.orderingReadinessReport
      temp['orderBy'] = this.orderingByReadinessReport
    }

    return temp
  }

  @action.bound
  getAllReadinessReport = async () => {
    try {
      this.allReadinessReportLoader = true
      let filters = this.getFiltersAllReadinessReport()
      let response = await this.post(API_ENDPOINTS.PROJECTS_READINES_REPORT, {
        ...filters,
        pageNo: Math.max(this.allReadinessReportPageNo - 1, 0),
        pageLimit: DEFAULT_PER_PAGE_RECORD,
      })
      if (response.status) {
        this.allReadinessReport = response.data?.projectReadinessReport || []
        this.allReadinessReportTotal = response.data?.total || 0
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.allReadinessReportLoader = false
    }
  }

  getAllReadinessReportExport = async ({ exportFileType = 'csv' } = {}) => {
    try {
      let filters = this.getFiltersAllReadinessReport()
      filters['exportFileType'] = exportFileType
      let response = await this.post(
        API_ENDPOINTS.PROJECTS_READINES_REPORT_EXPORT,
        {
          pageLimit: 0,
          ...filters,
        }
      )
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }
  // End Project Report Readiness

  @action.bound
  getStats = async () => {
    try {
      this.statsLoader = true
      let response = await this.get(API_ENDPOINTS.HOME_PROJECT_STATS_COUNT, {})
      if (response.status) {
        this.stats = response.data?.projectStatusCount || []
        this.statsTotalCount = response.data?.totalProjectCount || 0
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.statsLoader = false
    }
  }

  @action.bound
  getCountryWiseProjectsFilters = () => {
    let temp = {}
    this.countryNameForProjects &&
      (temp['country'] = this.countryNameForProjects)
    return temp
  }

  @action.bound
  getCountryWiseProjects = async (signal) => {
    try {
      this.countryWiseProjectsLoader = true
      let filters = this.getCountryWiseProjectsFilters() || {}
      let response = await this.get(
        API_ENDPOINTS.HOME_COUNTRY_GRAPH,
        {
          ...filters,
        },
        signal
      )
      if (response.status) {
        this.countryWiseProjectsTotal =
          (response.data?.projectCountryCount || []).reduce((acc, country) => {
            return acc + (country?.projectCount || 0)
          }, 0) || 0
        this.countryWiseProjects = response.data?.projectCountryCount || []
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.countryWiseProjectsLoader = false
    }
  }

  @action.bound
  getMonthWiseProjectsFilters = () => {
    let temp = {}
    this.monthYearForProjects &&
      (temp['year'] = this.monthYearForProjects?.year?.())
    return temp
  }

  @action.bound
  getMonthWiseProjects = async (signal) => {
    try {
      this.monthWiseProjectsLoader = true
      let filters = this.getMonthWiseProjectsFilters() || {}
      let response = await this.get(
        API_ENDPOINTS.HOME_BAR_GRAPH,
        {
          ...filters,
        },
        signal
      )
      if (response.status) {
        this.monthWiseProjectsTotal = response.data?.totalProjectCount || 0
        this.monthWiseProjects = response.data?.monthWiseCompleted || []
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.monthWiseProjectsLoader = false
    }
  }
  // OOS Project comment

  @action.bound
  setOOSCommentOrderingBy = async (value = '') => {
    this.ossCommentsOrderingBy = value
  }

  @action.bound
  setOOSCommentOrdering = async (value = '') => {
    this.ossCommentsOrdering = value
  }

  @action.bound
  setOOSCommentsCurrentPage = async (value = DEFAULT_PAGE_START) => {
    this.osscommentsCurrentPage = value
  }

  @action.bound
  setOOSCommentsSearchText = async (value = '') => {
    this.ossCommentsSearchText = value
  }

  @action.bound
  setOOSCommentFilters = async (value = {}) => {
    this.ossCommentsFilters = value
  }

  @action.bound
  getFiltersOOSComments = () => {
    let temp = {}
    this.ossCommentsSearchText && (temp['search'] = this.ossCommentsSearchText)
    let keys = Object.keys(this.ossCommentsFilters || {})
    for (let filter of keys) {
      if (this.ossCommentsFilters[filter] !== undefined) {
        temp[filter] = this.ossCommentsFilters[filter]
      }
    }
    if (this.ossCommentsOrdering) {
      temp['orderBy'] = this.ossCommentsOrderingBy
      temp['ordering'] = this.ossCommentsOrdering
    }
    return temp
  }

  @action.bound
  getDashboardOOSComment = async (signal) => {
    try {
      this.ossCommentsLoader = true
      let options = this.getFiltersOOSComments()
      let response = await this.post(
        API_ENDPOINTS?.HOME_OSS_PROJECT_COMMENT,
        {
          pageNo: Math.max(this.osscommentsCurrentPage - 1, 0),
          pageLimit: DEFAULT_PER_PAGE_RECORD,
          ...options,
        },
        signal
      )
      if (response?.status) {
        this.ossComments = response?.data?.comments || []
        this.spaceList = response?.data?.spaceDropdown || []
        this.userList = response?.data?.userDropdown || []
        this.ossCommentsTotal = response?.data?.total || 0
        return [true, response]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.ossCommentsLoader = false
    }
  }

  @action.bound
  getDashboardOOSCommentExport = async ({ exportFileType = 'csv' }) => {
    try {
      let options = this.getFiltersOOSComments()
      options['exportFileType'] = exportFileType
      let response = await this.post(
        API_ENDPOINTS?.HOME_OSS_PROJECT_COMMENT_EXPORT,
        { pageLimit: 0, ...options }
      )
      if (response?.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  resOOSetCommentFilters = async () => {
    this.ossCommentsFilters = undefined
  }

  //End OOS Project comment
  // Organization start
  @action.bound
  getTopOrganizations = async (signal) => {
    try {
      this.topOrganizationsLoader = true
      let response = await this.get(
        API_ENDPOINTS.HOME_TOP_ORGANIZATIN,
        {
          pageNo: 0,
          pageLimit: 10,
        },
        signal
      )
      if (response.status) {
        this.topOrganizations = response.data?.TopOrganizations || []
        this.topOrganizationsTotal = response.data?.thisPageCount || 0
      } else {
        return [false, undefined]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
      this.topOrganizationsLoader = false
    }
  }
  // End Organization start

  @action.bound
  resetStore = () => {
    this.customerVsProjectLoader = false
    this.customerVsProjectTotal = 0
    this.customerVsProjects = []
    this.projectVsResourcesLoader = false
    this.projectVsResourcesTotal = 0
    this.projectVsResources = []
    this.dashboardListActionItemsLoader = false
    this.dashboardListActionItemsTotal = 0
    this.dashboardListActionItems = []
    this.selectedProjectUser = undefined
    this.projectsPerUserTotal = 0
    this.projectsPerUsers = []
    this.projectsPerUserLoader = false
    this.projectsByUserAssignedLoader = false
    this.projectsByUsersAssigned = []
    this.projectsByUserLoader = false
    this.projectsByUserTotal = 0
    this.projectsByUsers = []
    this.dashboardReadinessReportLoader = false
    this.dashboardReadinessReportTotal = 0
    this.dashboardReadinessReport = []
    this.allReadinessReportFilters = {}
    this.allReadinessReportSearchText = ''
    this.allReadinessReportPageNo = DEFAULT_PAGE_START
    this.allReadinessReportDateChoice = undefined
    this.orderingReadinessReport = undefined
    this.orderingByReadinessReport = undefined
    this.allReadinessReportLoader = false
    this.allReadinessReportTotal = 0
    this.allReadinessReport = []
    this.statsLoader = false
    this.statsTotalCount = 0
    this.countryWiseProjectsLoader = false
    this.countryWiseProjectsTotal = 0
    this.countryNameForProjects = undefined
    this.currentSelecteCountry = undefined
    this.selectedCountry = undefined
    this.currentCountryData = undefined
    this.countryWiseProjects = []
    this.monthWiseProjectsLoader = false
    this.monthWiseProjectsTotal = 0
    this.monthYearForProjects = getCurrentTimeMoment()
    this.monthWiseProjects = []
    this.actionItemSearchText = ''
    this.actionItemsFilters = {}
    this.ordering = undefined
    this.orderingField = undefined
    this.pfSelectedDateChoice = undefined
    this.allActionItems = []
    this.allActionItemsLoader = false
    this.allActionItemsToal = 0
    this.allActionItemsPageNo = DEFAULT_PAGE_START
    this.topOrganizationsLoader = false
    this.topOrganizationsTotal = 0
    this.topOrganizations = []
    this.ossCommentsLoader = false
    this.ossComments = []
    this.userList = []
    this.spaceList = []
    this.ossCommentsTotal = 0
    this.osscommentsCurrentPage = DEFAULT_PAGE_START
    this.ossCommentsSearchText = ''
    this.ossCommentsFilters = {}
  }
}
